import script from "./ExamFormDevView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamFormDevView.vue?vue&type=script&setup=true&lang=ts"

import "./ExamFormDevView.vue?vue&type=style&index=0&id=ab710710&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab710710"]])

export default __exports__